// extracted by mini-css-extract-plugin
export default {"success":"Success_success__jHxwc"};